import React from 'react';
import PropTypes from 'prop-types';

import AccessibleIcon from '../common/AccessibleIcon';

const propTypes = {
    tagRecord: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        tag: PropTypes.string.isRequired,
        description: PropTypes.string,
    }),
    onDeleteTag: PropTypes.func,
    readOnly: PropTypes.bool,
    tooltipNode: PropTypes.node,
};

const defaultProps = {
    onDeleteTag: null,
    readOnly: false,
    tooltipNode: null,
};

function ActiveTagTableRow(props) {
    return (
        <li className="tagRow">
            <div className="tagCol">
                {props.tagRecord.tag}
                {props.tooltipNode}
            </div>
            <div className="tagCol tagDescription">
                {!!props.tagRecord &&
                    props.tagRecord.description
                }
            </div>
            {!!props.onDeleteTag && !props.readOnly &&
                <div className="tagCol__control">
                    <button className="bare-text-button glyph termListing__control" onClick={props.onDeleteTag}>
                        <AccessibleIcon label="Delete">
                            <span className="fa fa-remove" aria-hidden={true} />
                        </AccessibleIcon>
                    </button>
                </div>
            }
        </li>
    );
}

ActiveTagTableRow.propTypes = propTypes;
ActiveTagTableRow.defaultProps = defaultProps;

export default ActiveTagTableRow;